import { render, staticRenderFns } from "./LaborDashboard.vue?vue&type=template&id=591e497d"
import script from "./LaborDashboard.vue?vue&type=script&lang=js"
export * from "./LaborDashboard.vue?vue&type=script&lang=js"
import style0 from "./LaborDashboard.vue?vue&type=style&index=0&id=591e497d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports